/* eslint-disable @typescript-eslint/no-explicit-any */
import {ErrorHandler, inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ApplicationInsights, DistributedTracingModes} from '@microsoft/applicationinsights-web';
import {AngularPlugin} from './applicationinsights-angularplugin-js.component';
import {INSTRUMENTATION_CONFIG} from './instrumentation.config';

@Injectable()
export class Insights {

  // private logger = loggerFactory(Insights.name);

  // noinspection JSUnusedLocalSymbols
  private router = inject(Router);
  private config = inject(INSTRUMENTATION_CONFIG);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly angularPlugin: any;
  public readonly appInsights: ApplicationInsights;

  constructor() {
    console.info('applicationInsightsConnectionString:', this.config.applicationInsightsConnectionString);
    if (this.config.applicationInsightsConnectionString) {
      console.info('Creating ApplicationInsights');

      this.angularPlugin = new AngularPlugin();

      const appInsights = new ApplicationInsights({
        config: {
          distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
          enableAutoRouteTracking: true,
          autoTrackPageVisitTime: true,

          enableRequestHeaderTracking: true,
          enableResponseHeaderTracking: true,
          enableAjaxErrorStatusText: true,
          enableAjaxPerfTracking: true,
          enableUnhandledPromiseRejectionTracking: true,

          appId: this.config.appId,
          connectionString: this.config.applicationInsightsConnectionString,
          extensions: [this.angularPlugin],
          extensionConfig: {
            [this.angularPlugin.identifier]: {
              router: this.router,
              errorServices: [new ErrorHandler()],
            },
          },
        },
      });

      const telemetryInitializer = (envelope: any) => {
        envelope.tags['ai.cloud.role'] = this.config.appId;
        envelope.tags['ai.application.ver'] = this.config.appVersion;
        //  envelope.tags['ai.cloud.roleInstance'] = 'your role instance';
      };
      appInsights.addTelemetryInitializer(telemetryInitializer);

      // appInsights.addDependencyListener((details) => {
      //   // You have complete access to the xhr instance
      //   // details.xhr: XMLHttpRequest;
      //
      //   // Or if a fetch request you have complete access to the input and init objects
      //   // details.input: Request | string;
      //   // details.init: RequestInit;
      //
      //   const span = api.trace.getActiveSpan();
      //
      //   if (span) {
      //     const traceId = span.spanContext().traceId;
      //     const spanId = span.spanContext().spanId;
      //     const traceFlags = span.spanContext().traceFlags;
      //
      //     this.logger.log('traceId:', traceId, 'spanId:', spanId, 'traceFlags:', traceFlags);
      //
      //     // Access or change the W3C traceId that will be added to the outbound request
      //     details.traceId = traceId;
      //
      //     // Access or change the W3C spanId that will be added to the outbound request
      //     details.spanId = spanId;
      //
      //     // Access or change the W3C traceflags that will be added to the outbound request
      //     details.traceFlags = traceFlags;
      //   }
      //
      //   // // Access or change the W3C traceId that will be added to the outbound request
      //   // details.traceId = '';
      //   //
      //   // // Access or change the W3C spanId that will be added to the outbound request
      //   // details.spanId = '';
      //   //
      //   // // Access or change the W3C traceflags that will be added to the outbound request
      //   // details.traceFlags = 1;
      //
      //   // Add additional context values (any) that can be used by other listeners and is
      //   // also passed to any dependency initializers
      //   // details.context.someValue = 1234;
      // });

      this.appInsights = appInsights;
      this.appInsights.loadAppInsights();
    }

  }

  // expose methods that can be used in components and services
  trackEvent(name: string): void {
    if (this.appInsights !== undefined) {
      this.appInsights.trackEvent({name});
    }
  }

  trackTrace(message: string): void {
    if (this.appInsights !== undefined) {
      this.appInsights.trackTrace({message});
    }
  }
}
